import { render, staticRenderFns } from "./documentos_clientes.vue?vue&type=template&id=5de904dc&"
import script from "./documentos_clientes.vue?vue&type=script&lang=js&"
export * from "./documentos_clientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports